export const SCAN_USER_QR_REQUEST = 'SCAN_USER_QR_REQUEST'
export const SCAN_USER_QR_SUCCESS = 'SCAN_USER_QR_SUCCESS'
export const SCAN_USER_QR_FAILED = 'SCAN_USER_QR_FAILED'
export const SCAN_USER_QR_RESET = 'SCAN_USER_QR_RESET'

export const GENERATE_RECEIPT_REQUEST = 'GENERATE_RECEIPT_REQUEST'
export const GENERATE_RECEIPT_SUCCESS = 'GENERATE_RECEIPT_SUCCESS'
export const GENERATE_RECEIPT_FAILED = 'GENERATE_RECEIPT_FAILED'
export const GENERATE_RECEIPT_RESET = 'GENERATE_RECEIPT_RESET'

export const RETURNS_REQUEST = 'RETURNS_REQUEST'
export const RETURNS_SUCCESS = 'RETURNS_SUCCESS'
export const RETURNS_FAILED = 'RETURNS_FAILED'
export const RETURNS_RESET = 'RETURNS_RESET'

export const RETURNS_UPDATE_REQUEST = 'RETURNS_UPDATE_REQUEST'
export const RETURNS_UPDATE_SUCCESS = 'RETURNS_UPDATE_SUCCESS'
export const RETURNS_UPDATE_FAILED = 'RETURNS_UPDATE_FAILED'
export const RETURNS_UPDATE_RESET = 'RETURNS_UPDATE_RESET'
